/**
 * Hide the mobile splash with the same fade used by MobileHome.
 * The helper is shared so any mobile entry page can dismiss the overlay
 * as soon as its first paint happens.
 */
export const hideMobileSplash = (source: string, logdetails: string[] = []) => {
    const splash = document.getElementById('mobile-splash');
    const _logger = console.log;

    if (!splash) {
        logdetails.push('mobile-splash=missing');
        _logger(`[${source}]`, logdetails.join(' | '));
        return;
    }

    if (splash.style.display === 'none') {
        logdetails.push('mobile-splash=already-hidden');
        _logger(`[${source}]`, logdetails.join(' | '));
        return;
    }

    // Keep the existing fade timing so the splash disappears smoothly.
    requestAnimationFrame(() => {
        splash.style.transition = 'opacity 0.3s ease-out';
        splash.style.opacity = '0';
        logdetails.push('mobile-splash=fading');

        setTimeout(() => {
            splash.style.display = 'none';
            logdetails.push('mobile-splash=hidden');
            _logger(`[${source}]`, logdetails.join(' | '));
        }, 300);
    });
};
